module.exports = __webpack_public_path__ + "static/img/sample2.a6c3796.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sample2.jpg
// module id = eRxK
// module chunks = 1